
// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { Modal, Button, Form, Alert, Badge } from 'react-bootstrap';
// import axios from 'axios';
// import config from '../../Common/Configurations/APIConfig';
// import DefaultData from '../../Common/CompanyData/DefaultData';

// const ProductView = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();

//     // Data States
//     const [product, setProduct] = useState(null);
//     const [images, setImages] = useState([]); 
//     const [allProductImages, setAllProductImages] = useState([]); 
//     const [allProducts, setAllProducts] = useState([]);
    
//     // UI States
//     const [selectedImage, setSelectedImage] = useState('');
//     const [loading, setLoading] = useState(true);
//     const [quantity, setQuantity] = useState(1);
    
//     // Customer/User States
//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
//     const [showOrderModal, setShowOrderModal] = useState(false);
    
//     // Order States
//     const [customerName, setCustomerName] = useState('');
//     const [customerEmail, setCustomerEmail] = useState('');
//     const [customerPhone, setCustomerPhone] = useState('');
//     const [shippingAddress, setShippingAddress] = useState('');
//     const [orderLoading, setOrderLoading] = useState(false);
//     const [orderError, setOrderError] = useState('');
    
//     // Order Confirmation States
//     const [showConfirmation, setShowConfirmation] = useState(false);
//     const [orderConfirmation, setOrderConfirmation] = useState(null);

//     const THEME_COLOR = '#065f46';
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

//     // Helper to get the correct Image URL
//     const getFullImageUrl = (path) => {
//         if (!path) return 'https://placehold.co/500x500?text=No+Image';
//         if (path.startsWith('http')) return path;
//         const baseUrl = config.APIACTIVEURL.replace('/api/', '');
//         const cleanPath = path.startsWith('/') ? path : `/${path}`;
//         return `${baseUrl}${cleanPath}`;
//     };

//     useEffect(() => {
//         checkAuthStatus();
//         window.scrollTo(0, 0);
//         fetchProductData();
//     }, [id]);

//     const checkAuthStatus = () => {
//         const token = localStorage.getItem('token');
//         const user = localStorage.getItem('user');
        
//         if (token && user) {
//             setIsLoggedIn(true);
//             const parsedUser = JSON.parse(user);
//             setCurrentUser(parsedUser);
//             setCustomerName(parsedUser.name || '');
//             setCustomerEmail(parsedUser.email || '');
//             setCustomerPhone(parsedUser.phoneNumber || '');
//             setShippingAddress(parsedUser.address || '');
//         } else {
//             setIsLoggedIn(false);
//             setCurrentUser(null);
//             setCustomerName('');
//             setCustomerEmail('');
//             setCustomerPhone('');
//             setShippingAddress('');
//         }
//     };

//     const fetchProductData = async () => {
//         try {
//             setLoading(true);
//             const [prodRes, imgRes] = await Promise.all([
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
//                 axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
//             ]);

//             // Corrected spelling to productId
//             const foundProduct = prodRes.data.find(p => p.productId === id);
            
//             if (foundProduct) {
//                 setProduct(foundProduct);
//                 setAllProducts(prodRes.data);
//                 setAllProductImages(imgRes.data); 
                
//                 const foundImages = imgRes.data.filter(img => img.productId === foundProduct.productId);
//                 setImages(foundImages);
//                 setSelectedImage(foundImages[0] ? getFullImageUrl(foundImages[0].imageSrc) : 'https://placehold.co/500x500?text=No+Image');
//             }
//         } catch (error) {
//             console.error("Error fetching product", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleQuantity = (type) => {
//         if (type === 'plus' && quantity < (product?.quantityAvailable || 0)) {
//             setQuantity(quantity + 1);
//         }
//         if (type === 'minus' && quantity > 1) {
//             setQuantity(quantity - 1);
//         }
//     };

//     const validateCustomerDetails = () => {
//         if (!isLoggedIn) {
//             if (!customerName.trim()) { setOrderError('Please enter your name'); return false; }
//             if (!customerEmail.trim()) { setOrderError('Please enter your email'); return false; }
//             if (!shippingAddress.trim()) { setOrderError('Please enter shipping address'); return false; }
//         }
//         return true;
//     };

//     // FIXED: Corrected the payload structure to use the "items" array
//     const handlePlaceOrder = async () => {
//         setOrderError('');
//         if (!validateCustomerDetails()) return;

//         if (!product || product.quantityAvailable < quantity) {
//             setOrderError(`Only ${product?.quantityAvailable || 0} items available in stock`);
//             return;
//         }

//         setOrderLoading(true);
//         try {
//             const orderPayload = {
//                 email: (isLoggedIn ? currentUser.email : customerEmail).toLowerCase().trim(),
//                 customerName: (isLoggedIn ? currentUser.name : customerName).trim(),
//                 phoneNumber: (isLoggedIn ? (currentUser.phoneNumber || "") : (customerPhone || "")).toString().trim(),
//                 shippingAddress: shippingAddress.trim(),
//                 status: "Order Placed",
//                 // Wrap single product in the "items" array for the new backend
//                 items: [
//                     {
//                         productId: product.productId,
//                         quantity: quantity
//                     }
//                 ]
//             };

//             const response = await axios.post(config.APIACTIVEURL + config.CREATEORDER, orderPayload);
            
//             if (response.data.success) {
//                 const orderData = response.data.data;
//                 setOrderConfirmation({
//                     orderNo: orderData?.orderNo || 'N/A',
//                     productName: product.productName,
//                     quantity: quantity,
//                     totalAmount: orderData?.totalAmount || (product.sellingPrice * quantity),
//                     customerEmail: orderPayload.email,
//                     status: orderData?.status || 'Order Placed',
//                     orderTime: new Date().toLocaleString(),
//                     message: response.data.message
//                 });
//                 setShowConfirmation(true);
//             } else {
//                 setOrderError(response.data.message || 'Failed to place order');
//             }
            
//         } catch (error) {
//             setOrderError(error.response?.data?.message || 'Failed to place order. Check your connection.');
//         } finally {
//             setOrderLoading(false);
//         }
//     };

//     const handleOrderNow = () => {
//         setOrderError('');
//         setShowConfirmation(false);
//         setShowOrderModal(true);
//     };

//     const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

//     if (loading) return <div className="text-center py-5 mt-5"><div className="spinner-border text-success"></div></div>;
//     if (!product) return <div className="container py-5 mt-5">Product not found.</div>;

//     return (
//         <div style={{ backgroundColor: '#f4f7f6', minHeight: '100vh', paddingTop: '100px', paddingBottom: '80px' }}>
//             <div className="container">
//                 <nav className="mb-4">
//                     <small className="text-muted">
//                         <Link to="/" className="text-decoration-none text-muted">Home</Link> / 
//                         <span className="ms-1 fw-bold text-dark">{product.productName}</span>
//                     </small>
//                 </nav>

//                 <div className="row g-4 mb-5">
//                     <div className="col-lg-6">
//                         <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white mb-3 p-4 text-center">
//                             <img src={selectedImage} className="mw-100" style={{ height: '400px', objectFit: 'contain' }} alt="Product" />
//                         </div>
//                         <div className="d-flex gap-2 overflow-auto pb-2">
//                             {images.map((img, i) => (
//                                 <img key={i} src={getFullImageUrl(img.imageSrc)} 
//                                     onClick={() => setSelectedImage(getFullImageUrl(img.imageSrc))}
//                                     className="rounded-3 border shadow-sm"
//                                     style={{ width: '80px', height: '80px', objectFit: 'cover', cursor: 'pointer', border: selectedImage === getFullImageUrl(img.imageSrc) ? `2px solid ${THEME_COLOR}` : '1px solid #eee' }}
//                                 />
//                             ))}
//                         </div>
//                     </div>

//                     <div className="col-lg-6">
//                         <div className="ps-lg-4">
//                             <h1 className="fw-bold h2 mb-2">{product.productName}</h1>
//                             <h2 className="fw-bold mb-4" style={{ color: THEME_COLOR }}>{formatCurrency(product.sellingPrice)}</h2>

//                             <Badge bg={product.quantityAvailable > 0 ? "success" : "danger"} className="mb-3">
//                                 {product.quantityAvailable > 0 ? 'In Stock' : 'Out of Stock'}
//                             </Badge>

//                             <div className="mb-4">
//                                 <h6 className="fw-bold text-uppercase small text-muted mb-2">Description</h6>
//                                 <p className="text-secondary">{product.description || "Premium salon product."}</p>
//                             </div>

//                             <div className="p-3 rounded-4 mb-4 bg-white border shadow-sm">
//                                 <div className="row align-items-center">
//                                     <div className="col-6">
//                                         <div className="d-flex align-items-center border rounded-pill p-1">
//                                             <Button variant="link" className="text-dark" onClick={() => handleQuantity('minus')} disabled={quantity <= 1}>-</Button>
//                                             <span className="flex-grow-1 text-center fw-bold">{quantity}</span>
//                                             <Button variant="link" className="text-dark" onClick={() => handleQuantity('plus')} disabled={quantity >= product.quantityAvailable}>+</Button>
//                                         </div>
//                                     </div>
//                                     <div className="col-6 text-end">
//                                         <p className="small mb-0 text-muted">Total Payable</p>
//                                         <p className="h4 fw-bold mb-0">{formatCurrency(product.sellingPrice * quantity)}</p>
//                                     </div>
//                                 </div>
//                             </div>

//                             <button onClick={handleOrderNow} className="btn btn-lg w-100 rounded-pill text-white fw-bold shadow" style={{ backgroundColor: THEME_COLOR }} disabled={product.quantityAvailable <= 0}>
//                                 {orderLoading ? 'Processing...' : 'Order Now'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* ORDER MODAL */}
//             <Modal show={showOrderModal} onHide={() => setShowOrderModal(false)} size="lg" centered backdrop="static">
//                 <Modal.Header closeButton className="border-0">
//                     <Modal.Title className="fw-bold">Place Your Order</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {showConfirmation ? (
//                         <div className="text-center p-4">
//                             <i className="ri-checkbox-circle-fill text-success display-1"></i>
//                             <h3 className="fw-bold mt-3">Order Confirmed!</h3>
//                             <div className="alert alert-light border mt-4 text-start">
//                                 <p><strong>Order No:</strong> {orderConfirmation.orderNo}</p>
//                                 <p><strong>Product:</strong> {orderConfirmation.productName} (x{orderConfirmation.quantity})</p>
//                                 <p><strong>Total:</strong> {formatCurrency(orderConfirmation.totalAmount)}</p>
//                             </div>
//                             <Button onClick={() => { setShowOrderModal(false); navigate('/'); }} className="w-100 rounded-pill py-3 text-white border-0" style={{backgroundColor: THEME_COLOR}}>Return to Home</Button>
//                         </div>
//                     ) : (
//                         <Form onSubmit={(e) => { e.preventDefault(); handlePlaceOrder(); }}>
//                             {orderError && <Alert variant="danger">{orderError}</Alert>}
//                             <div className="row g-3">
//                                 {!isLoggedIn && (
//                                     <>
//                                         <div className="col-md-6"><Form.Control placeholder="Name" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
//                                         <div className="col-md-6"><Form.Control placeholder="Email" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
//                                         <div className="col-md-12"><Form.Control placeholder="Phone" value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} /></div>
//                                     </>
//                                 )}
//                                 <div className="col-md-12">
//                                     <Form.Control as="textarea" rows={3} placeholder="Shipping Address" value={shippingAddress} onChange={e => setShippingAddress(e.target.value)} required />
//                                 </div>
//                             </div>
//                             <div className="mt-4 d-flex justify-content-between align-items-center">
//                                 <h5 className="fw-bold mb-0">Total: {formatCurrency(product.sellingPrice * quantity)}</h5>
//                                 <Button type="submit" style={{backgroundColor: THEME_COLOR}} className="text-white px-5 rounded-pill py-2" disabled={orderLoading}>
//                                     {orderLoading ? 'Processing...' : 'Confirm Order'}
//                                 </Button>
//                             </div>
//                         </Form>
//                     )}
//                 </Modal.Body>
//             </Modal>
//         </div>
//     );
// };

// export default ProductView;
//web view 


import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Modal, Button, Form, Alert, Badge } from 'react-bootstrap';
import axios from 'axios';
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const ProductView = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [product, setProduct] = useState(null);
    const [images, setImages] = useState([]); 
    const [allProductImages, setAllProductImages] = useState([]); 
    const [allProducts, setAllProducts] = useState([]);
    
    const [selectedImage, setSelectedImage] = useState('');
    const [loading, setLoading] = useState(true);
    const [quantity, setQuantity] = useState(1);
    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [showOrderModal, setShowOrderModal] = useState(false);
    
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [shippingAddress, setShippingAddress] = useState('');
    const [orderLoading, setOrderLoading] = useState(false);
    const [orderError, setOrderError] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [orderConfirmation, setOrderConfirmation] = useState(null);

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    const getFullImageUrl = (path) => {
        if (!path) return 'https://placehold.co/500x500?text=No+Image';
        if (path.startsWith('http')) return path;
        const baseUrl = config.APIACTIVEURL.replace('/api/', '');
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${cleanPath}`;
    };

    useEffect(() => {
        checkAuthStatus();
        window.scrollTo(0, 0);
        fetchProductData();
    }, [id]);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        if (token && user) {
            setIsLoggedIn(true);
            const parsedUser = JSON.parse(user);
            setCurrentUser(parsedUser);
            setCustomerName(parsedUser.name || '');
            setCustomerEmail(parsedUser.email || '');
            setCustomerPhone(parsedUser.phoneNumber || '');
            setShippingAddress(parsedUser.address || '');
        } else {
            setIsLoggedIn(false);
            setCurrentUser(null);
        }
    };

    const fetchProductData = async () => {
        try {
            setLoading(true);
            const [prodRes, imgRes] = await Promise.all([
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES)
            ]);
            const foundProduct = prodRes.data.find(p => p.productId === id);
            if (foundProduct) {
                setProduct(foundProduct);
                setAllProducts(prodRes.data);
                setAllProductImages(imgRes.data); 
                const foundImages = imgRes.data.filter(img => img.productId === foundProduct.productId);
                setImages(foundImages);
                setSelectedImage(foundImages[0] ? getFullImageUrl(foundImages[0].imageSrc) : 'https://placehold.co/500x500?text=No+Image');
            }
        } catch (error) { console.error(error); } finally { setLoading(false); }
    };

    const handleQuantity = (type) => {
        if (type === 'plus' && quantity < (product?.quantityAvailable || 0)) { setQuantity(quantity + 1); }
        if (type === 'minus' && quantity > 1) { setQuantity(quantity - 1); }
    };

    const validateCustomerDetails = () => {
        if (!isLoggedIn) {
            if (!customerName.trim()) { setOrderError('Please enter your name'); return false; }
            if (!customerEmail.trim()) { setOrderError('Please enter your email'); return false; }
            if (!shippingAddress.trim()) { setOrderError('Please enter shipping address'); return false; }
        }
        return true;
    };

    const handlePlaceOrder = async () => {
        setOrderError('');
        if (!validateCustomerDetails()) return;
        if (!product || product.quantityAvailable < quantity) { setOrderError(`Only ${product?.quantityAvailable || 0} items available`); return; }
        setOrderLoading(true);
        try {
            const orderPayload = {
                email: (isLoggedIn ? currentUser.email : customerEmail).toLowerCase().trim(),
                customerName: (isLoggedIn ? currentUser.name : customerName).trim(),
                phoneNumber: (isLoggedIn ? (currentUser.phoneNumber || "") : (customerPhone || "")).toString().trim(),
                shippingAddress: shippingAddress.trim(),
                status: "Order Placed",
                items: [{ productId: product.productId, quantity: quantity }]
            };
            const response = await axios.post(config.APIACTIVEURL + config.CREATEORDER, orderPayload);
            if (response.data.success) {
                const orderData = response.data.data;
                setOrderConfirmation({ orderNo: orderData?.orderNo || 'N/A', productName: product.productName, quantity, totalAmount: orderData?.totalAmount || (product.sellingPrice * quantity), customerEmail: orderPayload.email, status: orderData?.status || 'Order Placed', orderTime: new Date().toLocaleString(), message: response.data.message });
                setShowConfirmation(true);
            } else { setOrderError(response.data.message || 'Failed to place order'); }
        } catch (error) { setOrderError(error.response?.data?.message || 'Failed to place order.'); } finally { setOrderLoading(false); }
    };

    const formatCurrency = (amount) => `${currency} ${amount?.toFixed(2) || '0.00'}`;

    if (loading) return <div className="text-center py-5 mt-5"><div className="spinner-border text-success"></div></div>;

    return (
        <div style={{ backgroundColor: '#f4f7f6', minHeight: '100vh' }} className="pt-5 mt-5 pb-5">
            <div className="container py-2">
                {/* Mobile Back Button */}
                <button onClick={() => navigate(-1)} className="btn border-0 p-0 mb-4 d-flex align-items-center text-dark shadow-none">
                    <i className="ri-arrow-left-line fs-3 me-2"></i><span className="fw-bold">Go Back</span>
                </button>

                <div className="row g-4 mb-5">
                    <div className="col-lg-6 text-center">
                        <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white mb-3 p-4">
                            <img src={selectedImage} className="mw-100" style={{ height: '350px', objectFit: 'contain' }} alt="Product" />
                        </div>
                        <div className="d-flex gap-2 overflow-auto pb-2">{images.map((img, i) => (
                            <img key={i} src={getFullImageUrl(img.imageSrc)} onClick={() => setSelectedImage(getFullImageUrl(img.imageSrc))} className="rounded-3 border" style={{ width: '70px', height: '70px', objectFit: 'cover', cursor: 'pointer', border: selectedImage === getFullImageUrl(img.imageSrc) ? `2px solid ${THEME_COLOR}` : '1px solid #eee' }} />
                        ))}</div>
                    </div>

                    <div className="col-lg-6 text-start">
                        <h1 className="fw-bold h3 mb-2">{product.productName}</h1>
                        <h2 className="fw-bold mb-4" style={{ color: THEME_COLOR }}>{formatCurrency(product.sellingPrice)}</h2>
                        <Badge bg={product.quantityAvailable > 0 ? "success" : "danger"} className="mb-4">{product.quantityAvailable > 0 ? 'In Stock' : 'Out of Stock'}</Badge>
                        <div className="mb-4"><h6 className="fw-bold text-uppercase small text-muted mb-2">Description</h6><p className="text-secondary small">{product.description || "Premium salon product."}</p></div>

                        <div className="p-3 rounded-4 mb-4 bg-white border shadow-sm">
                            <div className="row align-items-center">
                                <div className="col-6"><div className="d-flex align-items-center border rounded-pill p-1">
                                    <Button variant="link" className="text-dark" onClick={() => handleQuantity('minus')} disabled={quantity <= 1}>-</Button>
                                    <span className="flex-grow-1 text-center fw-bold">{quantity}</span>
                                    <Button variant="link" className="text-dark" onClick={() => handleQuantity('plus')} disabled={quantity >= product.quantityAvailable}>+</Button>
                                </div></div>
                                <div className="col-6 text-end"><p className="small mb-0 text-muted">Total</p><p className="h5 fw-bold mb-0">{formatCurrency(product.sellingPrice * quantity)}</p></div>
                            </div>
                        </div>

                        <button onClick={() => setShowOrderModal(true)} className="btn btn-lg w-100 rounded-pill text-white fw-bold shadow" style={{ backgroundColor: THEME_COLOR }} disabled={product.quantityAvailable <= 0}>Order Now</button>
                    </div>
                </div>
            </div>

            {/* ORDER MODAL - FULL ORIGINAL LOGIC */}
            <Modal show={showOrderModal} onHide={() => setShowOrderModal(false)} size="lg" centered backdrop="static">
                <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Place Your Order</Modal.Title></Modal.Header>
                <Modal.Body>
                    {showConfirmation ? (
                        <div className="text-center p-4"><i className="ri-checkbox-circle-fill text-success display-1"></i><h3 className="fw-bold mt-3">Confirmed!</h3><div className="alert alert-light border mt-4 text-start small">
                            <p><strong>Order No:</strong> {orderConfirmation.orderNo}</p>
                            <p><strong>Total:</strong> {formatCurrency(orderConfirmation.totalAmount)}</p>
                        </div><Button onClick={() => { setShowOrderModal(false); navigate('/'); }} className="w-100 rounded-pill py-3 text-white border-0" style={{backgroundColor: THEME_COLOR}}>Return Home</Button></div>
                    ) : (
                        <Form onSubmit={(e) => { e.preventDefault(); handlePlaceOrder(); }}>
                            {orderError && <Alert variant="danger" className="small">{orderError}</Alert>}
                            <div className="row g-3">
                                {!isLoggedIn && (<><div className="col-md-6"><Form.Control placeholder="Name" value={customerName} onChange={e => setCustomerName(e.target.value)} required /></div>
                                <div className="col-md-6"><Form.Control placeholder="Email" value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} required /></div>
                                <div className="col-md-12"><Form.Control placeholder="Phone" value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} /></div></>)}
                                <div className="col-md-12"><Form.Control as="textarea" rows={3} placeholder="Shipping Address" value={shippingAddress} onChange={e => setShippingAddress(e.target.value)} required /></div>
                            </div>
                            <div className="mt-4 d-flex justify-content-between align-items-center">
                                <h5 className="fw-bold mb-0">Total: {formatCurrency(product.sellingPrice * quantity)}</h5>
                                <Button type="submit" style={{backgroundColor: THEME_COLOR}} className="text-white px-5 rounded-pill py-2" disabled={orderLoading}>{orderLoading ? 'Processing...' : 'Confirm Order'}</Button>
                            </div>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ProductView;